import { authPost } from "../../common/redux/ApiClient";

const baseUrl = "35.240.204.237/es3KioskApi";

export function checkAccountCreditList(params) {
  return authPost(`${baseUrl}/Agent9.ashx`, params);
}
